import React from 'react'
import { Navbar, Header, Product, Getstarted, Planahead, Footer } from '../../components'
const Home = () => {
  return (
    <div>
      <Navbar></Navbar>
      <Header></Header>
      <Product></Product>
      <Getstarted/>
      <Planahead/>
      <Footer/>
    </div>
  )
}


export default Home
